import React, {PureComponent} from "react"
import {Row, Col} from "react-bootstrap"

import {FormattedMessage} from "@irati/utils/lang"
import Button, {IconButton} from "@irati/ui/src/Button"
import Form from "@irati/ui/src/Form"
import Flex from "@irati/ui/src/Flex"
import {H2, Body} from "@irati/ui/src/Typography"
import Icon, {IconTypes} from "@irati/ui/src/Icon"
import theme from "@irati/ui/src/global/theme"
import BURegion from "@irati-web/fields/team/BURegion"
import authentication from "@irati/auth"
import adminTracking from "@irati-tracking/admin"
import buService from "@irati/billing/services/bu"

import {ChooseCountryText} from "./styled"

const BULK_ADD_SOURCE = "People - Bulk add"

export type SelectOfficeCallback = (officeId?: string) => void

interface Props {
  selectOffice: SelectOfficeCallback,
  back(): void
}

interface State {
  office?: string,
  submit?: Promise<void>|null,
  isCountryNew: boolean
}

export default class AddPeopleSelectAnOffice extends PureComponent<Props, State> {
  state: State = {
    submit: null,
    isCountryNew: false
  }

  handleOfficeSelect = (office: string, {isCountryNew}: {isCountryNew: boolean}) => this.setState({office, isCountryNew})

  handleSubmit = async() => {
    const {office, isCountryNew} = this.state
    const businessId = authentication.business().uuid

    if (isCountryNew) {
      const submit = buService.createForRegion({businessId, regionId: office}).then(({teamId}) => {
        adminTracking.adminPeopleConfirmAddCountry(BULK_ADD_SOURCE)
        return this.props.selectOffice(teamId)
      })
      return this.setState({submit})
    }
    const {teamId} = await buService.getForRegionId({businessId, regionId: office})
    return this.props.selectOffice(teamId)
  }

  render() {
    const {office, submit, isCountryNew} = this.state
    const {back} = this.props
    const buttonText = isCountryNew ? "admin.components.addPeopleCSV.newCountryButton" : "platform.button.continue"

    return (
      <>
        <Flex alignItems="center" margin="0 0 30px 0">
          {back && <IconButton onClick={back} icon="backArrow" />}
        </Flex>
        <Form>
          <Row>
            <Col xsOffset={2} xs={8}>
              <H2 marginBottom={2}>
                <FormattedMessage id="admin.components.addPeopleCSV.selectOffice.header" />
              </H2>
            </Col>
            <Col xsOffset={2} xs={8}>
              <Body marginBottom={2}>
                <FormattedMessage id="admin.components.addPeopleCSV.selectCountry.body1" />
              </Body>
            </Col>
            <Col xsOffset={2} xs={8}>
              <Flex>
                <div>
                  <Icon icon={IconTypes.circleAlert} marginRight color={theme.colors.tertiary.o_400} />
                </div>
                <ChooseCountryText small marginBottom={4}>
                  <FormattedMessage id="admin.components.addPeopleCSV.selectCountry.body2" />
                </ChooseCountryText>
              </Flex>
            </Col>
            <Col xsOffset={2} xs={8}>
              <BURegion
                hideLabel
                separateExisting
                onChange={this.handleOfficeSelect}
                value={office}
                source={BULK_ADD_SOURCE}
                businessId={authentication.business().uuid} />
              <Flex justifyContent="center">
                <Button primary onClick={this.handleSubmit} load={submit}>
                  <FormattedMessage id={buttonText} />
                </Button>
              </Flex>
            </Col>
          </Row>
        </Form>
      </>
    )
  }
}
